var _excluded = ["ariaControls", "ariaControlsGuidance", "className", "explanation", "id", "inputRef", "inputRight", "label", "messages", "size", "shouldHideLabel", "type", "indeterminate"],
  _excluded2 = ["activeIndex", "autoFocusParent", "className", "disabled", "id", "label", "legend", "onChange", "options", "selectedOptions", "setOptionRefs", "shouldBeWrappedInFieldset", "shouldRememberIndeterminateState", "showLegend"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { PureComponent, createRef, useState, useRef, useEffect } from 'react';
import { Icon } from '@els/els-react--icon';
import { createEnum, makeErrorBoundComponent, generateId, appendClass, ValidPropTypes } from '@els/els-react--utils';
import Case from 'case';
import classnames from 'classnames';
import PT from 'prop-types';
var CheckboxSizes = createEnum(['default', 'small', 'large', 'xlarge']);
var CheckboxTypes = createEnum(['info', 'warn', 'confirm']);
var DefaultMessages = createEnum({
  required: 'Required'
});
var bool$1 = PT.bool,
  func$1 = PT.func,
  object = PT.object,
  oneOf = PT.oneOf,
  string$1 = PT.string;
var Checkbox = /*#__PURE__*/function (_PureComponent) {
  function Checkbox(props) {
    var _this;
    _classCallCheck(this, Checkbox);
    _this = _callSuper(this, Checkbox, [props]);
    _defineProperty(_this, "state", {
      checked: _this.props.checked && !_this.props.indeterminate,
      indeterminate: _this.props.indeterminate
    });
    _defineProperty(_this, "handleChange", function (e) {
      var onChange = _this.props.onChange;
      var checked = _this.state.checked;
      if (typeof onChange === "function") {
        onChange(e);
      }
      _this.checkboxRef.current.indeterminate = false;
      _this.setState({
        checked: !checked,
        indeterminate: false
      });
    });
    var _checked = props.checked,
      id = props.id,
      indeterminate = props.indeterminate,
      inputRef = props.inputRef,
      label = props.label;
    _this.checkboxRef = inputRef || createRef();
    if (process.env.NODE_ENV !== "production" && _checked && indeterminate) {
      console.warn("Checkbox cannot be both checked and indeterminate. Setting as indeterminate");
    }
    _this.inputId = id || Case.kebab("".concat(label, " ").concat(generateId()));
    return _this;
  }
  _inherits(Checkbox, _PureComponent);
  return _createClass(Checkbox, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var indeterminate = this.state.indeterminate;
      this.checkboxRef.current.indeterminate = indeterminate;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        checked = _this$props.checked,
        indeterminate = _this$props.indeterminate;
      if (prevProps.indeterminate !== indeterminate || prevProps.checked !== checked) {
        this.checkboxRef.current.indeterminate = indeterminate;
        this.setState({
          checked: checked && !indeterminate,
          indeterminate: indeterminate
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        ariaControls = _this$props2.ariaControls,
        ariaControlsGuidance = _this$props2.ariaControlsGuidance,
        className = _this$props2.className,
        explanation = _this$props2.explanation,
        id = _this$props2.id,
        inputRef = _this$props2.inputRef,
        inputRight = _this$props2.inputRight,
        label = _this$props2.label,
        messages = _this$props2.messages,
        size = _this$props2.size,
        shouldHideLabel = _this$props2.shouldHideLabel,
        type = _this$props2.type,
        removeFromInputProps = _this$props2.indeterminate,
        inputProps = _objectWithoutProperties(_this$props2, _excluded);
      var _this$state = this.state,
        checked = _this$state.checked,
        indeterminate = _this$state.indeterminate;
      var compiledMessages = _objectSpread(_objectSpread({}, DefaultMessages), messages);
      var baseClasses = ["checkbox", "c-els-field", className].join(" ");
      var wrapperClasses = classnames(baseClasses, "c-els-field--checkbox", "checkbox__wrapper", {
        "c-els-field--small": size === CheckboxSizes.SMALL,
        "c-els-field--large": size === CheckboxSizes.LARGE,
        "c-els-field--x-large": size === CheckboxSizes.XLARGE,
        "c-els-field--checkbox-indeterminate": indeterminate,
        "c-els-field--input-right": inputRight,
        "c-els-field--type-info": type === CheckboxTypes.INFO,
        "c-els-field--type-warn": type === CheckboxTypes.WARN,
        "c-els-field--type-confirm": type === CheckboxTypes.CONFIRM
      });
      var labelClasses = appendClass({
        className: baseClasses,
        value: "label",
        delimiter: "__"
      });
      var inputClasses = appendClass({
        className: baseClasses,
        value: "input",
        delimiter: "__"
      });
      var labelTextClasses = appendClass({
        className: baseClasses,
        value: "label-text",
        delimiter: "__"
      });
      var labelTextValueClasses = classnames({
        "u-els-hide-visually": shouldHideLabel
      });
      var switchClasses = appendClass({
        className: baseClasses,
        value: "switch",
        delimiter: "__"
      });
      return /* @__PURE__ */React.createElement("div", {
        className: wrapperClasses,
        id: this.inputId,
        "data-testid": "checkbox"
      }, /* @__PURE__ */React.createElement("label", {
        className: labelClasses,
        htmlFor: "".concat(this.inputId, "-input"),
        id: "".concat(this.inputId, "-label")
      }, /* @__PURE__ */React.createElement("input", _objectSpread(_objectSpread({}, inputProps), {}, {
        id: "".concat(this.inputId, "-input"),
        className: inputClasses,
        ref: this.checkboxRef,
        type: "checkbox",
        onChange: this.handleChange,
        checked: checked,
        "aria-controls": ariaControls,
        "aria-describedby": explanation || ariaControlsGuidance ? "".concat(this.inputId, "-explanation") : null,
        "data-testid": "checkbox-input"
      })), /* @__PURE__ */React.createElement("span", {
        className: labelTextClasses,
        id: "".concat(this.inputId, "-label-text")
      }, /* @__PURE__ */React.createElement("span", {
        className: switchClasses
      }, /* @__PURE__ */React.createElement(Icon, {
        isDecorative: true,
        sprite: "Checkmark",
        size: "stretch",
        textAlignment: "top",
        className: "c-els-field__checkbox-icon",
        fallback: (/* istanbul ignore next */
        function fallback() {
          return checked ? "✔" : "";
        })
      })), label && /* @__PURE__ */React.createElement("span", {
        className: labelTextValueClasses,
        "data-testid": "checkbox-label"
      }, inputProps.required && /* @__PURE__ */React.createElement("span", {
        className: "c-els-field__label-required-indicator"
      }, "*", /* @__PURE__ */React.createElement("span", {
        className: "u-els-hide-visually"
      }, "(", compiledMessages.REQUIRED, ")")), label)), (explanation || ariaControlsGuidance) && /* @__PURE__ */React.createElement("div", {
        className: explanation && "u-els-margin-top-1o2",
        id: "".concat(this.inputId, "-explanation")
      }, explanation && /* @__PURE__ */React.createElement("span", {
        "data-testid": "explanation-test-element"
      }, explanation), ariaControlsGuidance && /* @__PURE__ */React.createElement("span", {
        className: "u-els-hide-visually",
        "data-testid": "ariaControlsGuidance-test-element"
      }, ariaControlsGuidance))));
    }
  }]);
}(PureComponent);
Checkbox.displayName = "Checkbox";
Checkbox.propTypes = {
  /**
   * aria label to note which elements this one controls
   * @see https://www.w3.org/TR/wai-aria-1.1/#aria-controls
   */
  ariaControls: string$1,
  /**
   * Accessibility guidance explaining what the connection of the checkbox
   * is to other elements on the page
   */
  ariaControlsGuidance: string$1,
  /** The checkbox should display as checked */
  checked: bool$1,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string$1,
  /** Standard HTML disabled attribute */
  disabled: bool$1,
  /** An optional paragraph explaining the purpose of the checkbox */
  explanation: string$1,
  /**
   * id needed for linking input and label elements.
   * If id is not provided an id will be generated from the label
   */
  id: string$1,
  /** The checkbox should display as indeterminate */
  indeterminate: bool$1,
  /** A React ref applied to the input element */
  inputRef: object,
  /** The checkbox should display on the right of the label */
  inputRight: bool$1,
  /** The label for the input */
  label: string$1,
  /** Messages for internationalization */
  messages: object,
  /** Show a 'required' asterisk and associated hidden descriptive text */
  required: bool$1,
  /** The checkbox's label should be hidden */
  shouldHideLabel: bool$1,
  /** Size of the checkbox */
  size: oneOf(CheckboxSizes.getAll()),
  /** Type of the checkbox */
  type: oneOf(CheckboxTypes.getAll()),
  /**
   * Custom change callback
   * @param e - the onChange synthetic event from React
   * */
  onChange: func$1
};
Checkbox.requiredProps = {};
Checkbox.defaultProps = {
  ariaControls: null,
  ariaControlsGuidance: null,
  checked: false,
  className: "",
  disabled: false,
  explanation: null,
  id: null,
  indeterminate: false,
  inputRef: null,
  inputRight: false,
  label: "",
  messages: DefaultMessages,
  required: false,
  shouldHideLabel: false,
  size: CheckboxSizes.DEFAULT,
  type: null,
  onChange: null
};
Checkbox.Sizes = CheckboxSizes;
Checkbox.Types = CheckboxTypes;
Checkbox.DefaultMessages = DefaultMessages;
var RawCheckbox = Checkbox;
var Checkbox$1 = makeErrorBoundComponent(RawCheckbox);
var arrayOf = PT.arrayOf,
  bool = PT.bool,
  func = PT.func,
  number = PT.number,
  shape = PT.shape,
  string = PT.string;
var CheckState = createEnum(["unchecked", "indeterminate", "checked"]);
var getCheckState = function getCheckState(options, selectedOptions) {
  var optionsTotal = options.length;
  var selectedTotal = selectedOptions.length;
  var checkState = CheckState.CHECKED;
  if (selectedTotal === 0) {
    checkState = CheckState.UNCHECKED;
  } else if (selectedTotal > 0 && selectedTotal < optionsTotal) {
    checkState = CheckState.INDETERMINATE;
  }
  return checkState;
};
var TristateCheckbox = function TristateCheckbox(_ref) {
  var _Object$values, _Object$values2;
  var activeIndex = _ref.activeIndex,
    autoFocusParent = _ref.autoFocusParent,
    className = _ref.className,
    disabled = _ref.disabled,
    id = _ref.id,
    topLevelLabel = _ref.label,
    legend = _ref.legend,
    onChange = _ref.onChange,
    options = _ref.options,
    propSelectedOptions = _ref.selectedOptions,
    setOptionRefs = _ref.setOptionRefs,
    shouldBeWrappedInFieldset = _ref.shouldBeWrappedInFieldset,
    shouldRememberIndeterminateState = _ref.shouldRememberIndeterminateState,
    showLegend = _ref.showLegend,
    checkboxProps = _objectWithoutProperties(_ref, _excluded2);
  var _useState = useState((_Object$values = Object.values(propSelectedOptions)) !== null && _Object$values !== void 0 && _Object$values.length ? propSelectedOptions : []),
    _useState2 = _slicedToArray(_useState, 2),
    selectedOptions = _useState2[0],
    setSelectedOptions = _useState2[1];
  var _useState3 = useState((_Object$values2 = Object.values(propSelectedOptions)) !== null && _Object$values2 !== void 0 && _Object$values2.length ? propSelectedOptions : options.map(function (_ref2) {
      var value = _ref2.value;
      return value;
    })),
    _useState4 = _slicedToArray(_useState3, 2),
    oldIndeterminateState = _useState4[0],
    setOldIndeterminateState = _useState4[1];
  var _useState5 = useState(options.reduce(function (newSelectedOptions, _ref3) {
      var value = _ref3.value;
      return _objectSpread(_objectSpread({}, newSelectedOptions), {}, _defineProperty({}, value, id ? "".concat(id, "-").concat(value) : generateId()));
    }, {})),
    _useState6 = _slicedToArray(_useState5, 1),
    optionsIds = _useState6[0];
  var prevPropSelectedOptions = useRef();
  useEffect(function () {
    if (Array.isArray(prevPropSelectedOptions.current) && prevPropSelectedOptions.current.length && !propSelectedOptions.length) {
      setSelectedOptions(propSelectedOptions);
      setOldIndeterminateState(options.map(function (_ref4) {
        var value = _ref4.value;
        return value;
      }));
    } else if (Array.isArray(prevPropSelectedOptions.current) && JSON.stringify(prevPropSelectedOptions.current) !== JSON.stringify(propSelectedOptions)) {
      setSelectedOptions(propSelectedOptions);
      setOldIndeterminateState(propSelectedOptions);
    }
  },
  // This has to be stringified as the dependency
  // check is a shallow equality check, so
  // reference types won't always trigger the hook
  // to run again
  [JSON.stringify(propSelectedOptions)]);
  useEffect(function () {
    prevPropSelectedOptions.current = propSelectedOptions;
  });
  var handleTopOptionChange = function handleTopOptionChange(event) {
    var checkState2 = getCheckState(options, selectedOptions);
    var newSelectedOptions;
    if (checkState2 === CheckState.UNCHECKED) {
      newSelectedOptions = _toConsumableArray(oldIndeterminateState);
      if (!shouldRememberIndeterminateState) {
        newSelectedOptions = _toConsumableArray(options.map(function (_ref5) {
          var value = _ref5.value;
          return value;
        }));
      }
      setSelectedOptions(newSelectedOptions);
    } else if (checkState2 === CheckState.INDETERMINATE) {
      newSelectedOptions = _toConsumableArray(options.map(function (_ref6) {
        var value = _ref6.value;
        return value;
      }));
      setSelectedOptions(newSelectedOptions);
    } else {
      newSelectedOptions = [];
      setSelectedOptions(newSelectedOptions);
    }
    if (onChange) {
      onChange(newSelectedOptions, event);
    }
  };
  var handleOptionChange = function handleOptionChange(event) {
    var value = event.target.value;
    var newSelectedOptions = _toConsumableArray(selectedOptions);
    var optionIndex = newSelectedOptions.indexOf(value);
    if (optionIndex >= 0) {
      newSelectedOptions.splice(optionIndex, 1);
    } else {
      newSelectedOptions.push(value);
    }
    if (getCheckState(options, newSelectedOptions) === CheckState.INDETERMINATE) {
      setOldIndeterminateState(newSelectedOptions);
    }
    if (onChange) {
      onChange(newSelectedOptions, event);
    }
    setSelectedOptions(newSelectedOptions);
  };
  var setRef = function setRef(ref, innerIndex) {
    if (setOptionRefs) {
      setOptionRefs(ref, innerIndex);
    }
  };
  var classes = classnames("c-els-field--tristate-checkbox", className);
  var legendClassName = classnames("c-els-field__legend", {
    "u-els-hide-visually": !showLegend
  });
  var getOptionsClassName = function getOptionsClassName() {
    return classnames("c-els-field__nested-checkbox");
  };
  var checkState = getCheckState(options, selectedOptions);
  var ariaControls = Object.values(optionsIds).join(" ");
  var contents = /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(Checkbox$1, _objectSpread({
    ariaControls: ariaControls,
    checked: checkState === CheckState.CHECKED,
    indeterminate: checkState === CheckState.INDETERMINATE,
    label: topLevelLabel,
    onChange: handleTopOptionChange,
    ref: function ref(_ref7) {
      return setRef(_ref7, 0);
    },
    id: id,
    autoFocus: autoFocusParent
  }, checkboxProps)), /* @__PURE__ */React.createElement("ul", null, options.map(function (_ref8, index) {
    var label = _ref8.label,
      value = _ref8.value;
    return /* @__PURE__ */React.createElement("li", {
      key: Case.kebab(value)
    }, /* @__PURE__ */React.createElement(Checkbox$1, _objectSpread(_objectSpread({}, checkboxProps), {}, {
      checked: selectedOptions.includes(value),
      className: getOptionsClassName(),
      id: optionsIds[value],
      label: label,
      onChange: handleOptionChange,
      value: value,
      ref: function ref(_ref9) {
        return setRef(_ref9, index + 1);
      }
    })));
  })));
  return shouldBeWrappedInFieldset ? /* @__PURE__ */React.createElement("fieldset", {
    className: classes,
    disabled: disabled,
    id: id
  }, legend && /* @__PURE__ */React.createElement("legend", {
    className: legendClassName
  }, legend), contents) : contents;
};
TristateCheckbox.Sizes = Checkbox$1.Sizes;
TristateCheckbox.displayName = "TristateCheckbox";
TristateCheckbox.propTypes = {
  /** active checkbox index */
  activeIndex: number,
  /** autofocus the parent checkbox */
  autoFocusParent: bool,
  /** Allow custom classes for outward-looking styling (margins, width) of the component */
  className: string,
  /** Are the checkboxes disabled */
  disabled: bool,
  /** id for top-level fieldset */
  id: string,
  /** Label for the top level checkbox */
  label: string.isRequired,
  /** Legend text */
  legend: string,
  /** Array of options to use */
  options: arrayOf(shape({
    label: string,
    value: string
  })).isRequired,
  selectedOptions: arrayOf(string),
  /** function for setting option ref */
  setOptionRefs: func,
  /** Should the checkboxes be wrapped in a fieldset. Only used internally to Leyden, by NestedSelect */
  shouldBeWrappedInFieldset: bool,
  /** Should the top checkbox remember the previous indeterminate state */
  shouldRememberIndeterminateState: bool,
  /** Show the legend */
  showLegend: bool,
  /** Size of the checkboxes */
  size: string,
  /**
   * Custom change callback
   * @param e - the onChange synthetic event from React
   * */
  onChange: func
};
TristateCheckbox.requiredProps = {
  label: ValidPropTypes.STRING,
  options: ValidPropTypes.ARRAY
};
TristateCheckbox.defaultProps = {
  autoFocusParent: false,
  className: "",
  disabled: false,
  id: "",
  legend: "",
  onChange: null,
  selectedOptions: [],
  shouldBeWrappedInFieldset: true,
  shouldRememberIndeterminateState: true,
  size: Checkbox$1.Sizes.DEFAULT,
  showLegend: true,
  activeIndex: 0,
  setOptionRefs: void 0
};
var RawTristateCheckbox = TristateCheckbox;
var TristateCheckbox$1 = makeErrorBoundComponent(RawTristateCheckbox);
export { Checkbox$1 as Checkbox, RawCheckbox, RawTristateCheckbox, TristateCheckbox$1 as TristateCheckbox };
